<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.siteIds"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.terminalIds"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">月份：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="monthSelect"
            mode="multiple"
            v-model:value="tempMonths"
            @openChange="
              open => {
                monthSelectOpen = open
              }
            "
            style="width: 220px"
          >
            <template #dropdownRender="{ menuNode: menu }">
              <div
                style="padding: 8px 12px; border-bottom: 1px solid #f0f0f0; display: flex; justify-content: space-between; align-items: center;"
                @mousedown.stop
              >
                <div style="display: flex; gap: 8px;">
                  <a-button
                    type="link"
                    size="small"
                    @click.stop="selectAllMonths"
                    >全选</a-button
                  >
                  <a-button
                    type="link"
                    size="small"
                    @click.stop="clearAllMonths"
                    >取消全选</a-button
                  >
                </div>
                <a-button
                  type="primary"
                  size="small"
                  @click.stop="confirmMonthSelection"
                  >确认</a-button
                >
              </div>
              <a-divider style="margin: 4px 0" />
              <v-nodes :vnodes="menu" />
            </template>
            <a-select-option
              :value="item.value"
              v-for="(item, key) in [...monthOptions]"
              :key="key"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">场景：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.themeType"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option :value="2" key="vacation"
              >beachwear</a-select-option
            >
            <a-select-option :value="1" key="everyday"
              >resortwear</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">二级类目：</div>
        <div class="fl">
          <a-cascader
            v-model:value="searchParams.categoryInfo"
            :options="cascaderOptions"
            style="width: 220px"
            placeholder="请选择类目"
            @change="initList"
            multiple
            show-checked-strategy="SHOW_CHILD"
            max-tag-count="responsive"
            :field-names="fieldNames"
          />
        </div>
      </div>
    </div>

    <div class="tar mt20">
      <a-button type="primary" @click="() => changeVisible(true, null)"
        >批量新增</a-button
      >
    </div>
  </div>
</template>
<script>
import { inject, toRefs, ref, watch, onMounted, nextTick } from 'vue'
export default {
  components: {
    VNodes: (_, { attrs }) => {
      if (!attrs || !attrs.vnodes) {
        return null
      }
      return attrs.vnodes
    }
  },
  setup() {
    const initState = inject('initState')
    const monthSelect = ref(null)
    const monthSelectOpen = ref(false)

    // 临时存储选中的月份，确认时才更新到searchParams
    const tempMonths = ref(
      initState.searchParams.months &&
        Array.isArray(initState.searchParams.months)
        ? [...initState.searchParams.months]
        : []
    )

    // 监听searchParams.months的变化，同步到tempMonths（避免外部更新时不同步）
    watch(
      () => initState.searchParams.months,
      newVal => {
        // 只有当tempMonths与searchParams不同时才更新，避免循环
        if (!newVal || !Array.isArray(newVal)) return
        const newValSorted = [...newVal].sort()
        const tempMonthsSorted = [...(tempMonths.value || [])].sort()
        if (JSON.stringify(tempMonthsSorted) !== JSON.stringify(newValSorted)) {
          tempMonths.value = [...newVal]
        }
      },
      { deep: true }
    )

    // 全选所有月份
    const selectAllMonths = () => {
      tempMonths.value = initState.monthOptions.map(item => item.value)
      confirmMonthSelection()
    }

    // 取消全选
    const clearAllMonths = () => {
      tempMonths.value = []
      confirmMonthSelection()
    }

    // 确认选择，更新searchParams并调用接口
    const confirmMonthSelection = () => {
      initState.searchParams.months = [...tempMonths.value]
      initState.initList()
      // 关闭下拉框
      nextTick(() => {
        if (monthSelect.value) {
          monthSelect.value.blur()
        }
      })
    }

    onMounted(() => {
      // 确保初始化完成
      if (
        initState.searchParams.months &&
        Array.isArray(initState.searchParams.months)
      ) {
        tempMonths.value = [...initState.searchParams.months]
      }
    })

    return {
      ...toRefs(initState),
      monthSelect,
      monthSelectOpen,
      tempMonths,
      selectAllMonths,
      clearAllMonths,
      confirmMonthSelection
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
